<template>
    <div class="tw:space-y-4">
        <div class="tw:mb-4 tw:px-6">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">
                Datos tarjeta
            </h2>
            <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:my-1">
                Información de pago del usuario
            </p>
        </div>

        <div class="tw:p-6">
            <p class="tw:text-sm tw:text-gray-500 tw:mb-4">
                <strong class="tw:text-red-500">* </strong>
                Modificar esta información de pago afectará al usuario, es decir al cobro de deportistas, abonos, etc...
            </p>

            <InformacionPago
                :lista-id="listaId"
                :user-id="userId"
                :tid="tid"
                @editar="showEditModal"
            />
        </div>

        <EditarInfoPagoModal
            :tid="tid"
            :user-id="userId"
            :nueva-alta="!user || !user.info_pago"
            @close="onModalClose"
            @setActive="onCardAdded"
        />
    </div>
</template>

<script setup>
    import { getCurrentInstance } from 'vue';
    import InformacionPago from '@/modules/admin/usuarios/components/InformacionPago.vue';
    import EditarInfoPagoModal from '@/modules/admin/usuarios/components/modals/EditarInfoPagoModal.vue';

    const props = defineProps({
        user: { type: Object, default: null },
        userId: { type: [String, Number], required: true },
        tid: { type: String, default: '' },
        listaId: { type: [String, Number], required: true },
    });

    const emit = defineEmits(['actualizarInfo']);

    const instance = getCurrentInstance();

    function showEditModal() {
        instance.proxy.$modal.show('editarInfo');
    }

    function onModalClose() {
        emit('actualizarInfo');
        instance.proxy.$modal.hide('editarInfo');
    }

    function onCardAdded() {
        emit('actualizarInfo');
    }
</script>
